module.exports = __webpack_public_path__ + "img/website-08.e1fcc730.png";